import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  isSocketConnected: false,
  notifications: []
};

const SocketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    toggleSocketStatus(state, { payload }) {
      state.isSocketConnected = payload;
    },
    addNotification(state, { payload }) {
      const notification = { ...payload.message, targetUrl: payload.targetUrl, id: payload.id };
      if (state.notifications.length === 0) {
        state.notifications.push(notification);
      } else if (state.notifications.findIndex((n) => n.id === notification.id) === -1) {
        state.notifications.push(notification);
      } else {
        state.notifications = state.notifications.map((n) => {
          if (notification.id === n.id) {
            notification.seen = false;
          }
          return notification;
        });
      }
      state.notification = _.uniqBy(state.notifications, 'id');
    },
    readNotification(state, { payload }) {
      state.notifications = state.notifications.map((notification) => {
        if (notification.id === payload) {
          notification.seen = true;
        }
        return notification;
      });
    }
  },
  extraReducers: (builder) => {
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default SocketSlice.reducer;
export const SocketActions = SocketSlice.actions;
